var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('tabs',{staticClass:"mb-3",attrs:{"items":_vm.sections,"active-item":_vm.section,"is-card":""},on:{"item-change":function($event){_vm.section = $event}}}),_c('div',{staticClass:"col-12 p-0"},[_c(_vm.section.value,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }